/* A tenant user's role (docs/API.md → Enums, TenantRole; Permissions, §13.2). */
export enum TenantRole {
    Admin        = 'admin',
    Editor       = 'editor',
    Reception    = 'reception',
    Kitchen      = 'kitchen',
    /** The screens on site only: the field view (docs/API.md §16). */
    Technician   = 'technician',
    /** Housekeeping requests only (§13.6). */
    Housekeeping = 'housekeeping',
}

export const TENANT_ROLES: TenantRole[] = [TenantRole.Admin, TenantRole.Editor, TenantRole.Reception, TenantRole.Kitchen, TenantRole.Technician, TenantRole.Housekeeping]

/*
 * CLOSED ROLES (docs/API.md §13.2, §13.6): a kitchen or housekeeping user may open only the pages
 * that name its role (route meta `closed`, the menu's `closed`); every other tenant route answers
 * 403 to it. Both land on the guest-requests inbox. (A technician has the field view instead.)
 */
export const CLOSED_ROLES: TenantRole[] = [TenantRole.Kitchen, TenantRole.Housekeeping]
